module.exports = __webpack_public_path__ + "img/7.86350237.jpg";